import { c as _c } from "react/compiler-runtime";
import type { Driver } from '@cc-shopping/contracts/cross-site/marketplace/types';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '@cc-shopping/structured-content-renderer/hydration/types';
import { renderStructuredContent } from '@cc-shopping/structured-content-renderer/renderContext';
import { CreditCardsMultiCompareSectionClient } from './CreditCardsMultiCompareSection.client';
export type CreditCardsMultiCompareSectionProps = StructuredContentDocumentWithRenderer<{
  driver?: Driver;
  title?: string;
  hideDriver?: boolean;
  hideCustomContent?: boolean;
  ctaType: string;
  children: StructuredContentDocument;
}>;
export const CreditCardsMultiCompareSection = t0 => {
  const $ = _c(8);
  const {
    props
  } = t0;
  let children;
  let restProps;
  if ($[0] !== props) {
    ({
      children,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = restProps;
  } else {
    children = $[1];
    restProps = $[2];
  }
  let t1;
  if ($[3] !== children) {
    t1 = renderStructuredContent(children);
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== restProps || $[6] !== t1) {
    t2 = <CreditCardsMultiCompareSectionClient {...restProps} renderedChildren={t1} />;
    $[5] = restProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};